"use strict";

exports.__esModule = true;
exports.formatPlantActivity = formatPlantActivity;
exports.formatPlantState = formatPlantState;
function formatPlantState(plantStateActivities, stateId) {
  if (!plantStateActivities) {
    return stateId;
  }
  var state = plantStateActivities.states.find(function (s) {
    return s.id === stateId;
  });
  return state ? state.name : stateId;
}
function formatPlantActivity(plantStateActivities, activityId) {
  if (!plantStateActivities) {
    return activityId;
  }
  var state = plantStateActivities.activities.find(function (s) {
    return s.id === activityId;
  });
  return state ? state.name : decodeURIComponent(activityId);
}